import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que transforma el valor "-1" a "Heredado" para mejor visualización.
 *
 * Este pipe se usa en las tablas de Condiciones y Acciones para mostrar
 * "Heredado" en lugar de "-1" cuando el valor de saveValue es "-1".
 *
 * **Importante:** Este pipe solo afecta la visualización, no modifica
 * el valor real almacenado en la base de datos.
 *
 * @example
 * // En el template:
 * {{ condition.saveValue | inherited }}
 *
 * // Si saveValue = "-1" → muestra "Heredado"
 * // Si saveValue = "100170" → muestra "100170"
 * // Si saveValue = null/undefined → muestra cadena vacía
 */
@Pipe({
  name: 'inherited',
})
export class InheritedPipe implements PipeTransform {
  /**
   * Transforma "-1" a "Heredado", manteniendo otros valores sin cambios.
   *
   * @param {string | number | null | undefined} value - El valor a transformar
   * @returns {string} "Heredado" si el valor es "-1", el valor original en otros casos
   */
  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }

    // Convertir a string para comparar
    const stringValue = String(value).trim();

    // Si es "-1", retornar "Heredado"
    if (stringValue === '-1') {
      return 'Heredado';
    }

    // En cualquier otro caso, retornar el valor original como string
    return stringValue;
  }
}

